module.exports = __webpack_public_path__ + "img/tree-4.aeb41c3d.png";